// extracted by mini-css-extract-plugin
export var label = "_em-2";
export var slideContainer = "_em-0";
export var slider = "_em-1";